import React, { useState, Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createProfile, getCurrentProfile } from "../../actions/profile";
import { withRouter, Link } from "react-router-dom";

const EditProfile = ({
  profile: { profile, loading },
  createProfile,
  history,
  getCurrentProfile,
}) => {
  const [formData, setFormData] = useState({
    college: "",
    website: "",
    location: "",
    bio: "",
    linkedin: "",
    youtube: "",
    github: "",
  });

  const [displaySocialInputs, toggleSocialInputs] = useState(false);

  useEffect(() => {
    getCurrentProfile();

    setFormData({
      college: loading || !profile.college ? "" : profile.college,
      website: loading || !profile.website ? "" : profile.website,
      location: loading || !profile.location ? "" : profile.location,
      bio: loading || !profile.bio ? "" : profile.bio,
      github: loading || !profile.social ? "" : profile.social.github,
      linkedin: loading || !profile.social ? "" : profile.social.linkedin,
      youtube: loading || !profile.social ? "" : profile.social.youtube,
    });
  }, [loading, getCurrentProfile]);

  const {
    college,
    website,
    location,
    bio,
    linkedin,
    youtube,
    github,
  } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    createProfile(formData, history, true);
  };

  return (
    <Fragment>
      <div className='container-fluid profile'>
        <div className='row'>
          <div className='col-10 mx-auto'>
            <div className='row'>
              <div className='col-sm-12'>
                <h1>Create Your Profile</h1>
                <p>
                  <i className='fas fa-user'></i> Let's get some information to
                  make your profile stand out
                </p>
                <form onSubmit={(e) => onSubmit(e)}>
                  <div className='form-group'>
                    <input
                      type='text'
                      placeholder='College'
                      name='college'
                      value={college}
                      onChange={(e) => onChange(e)}
                    />
                    <p className='form-text'>
                      Could be your own company or one you work for
                    </p>

                    <input
                      type='text'
                      placeholder='Website'
                      name='website'
                      value={website}
                      onChange={(e) => onChange(e)}
                    />
                    <p>Could be your own or a company website</p>

                    <input
                      type='text'
                      placeholder='Location'
                      name='location'
                      value={location}
                      onChange={(e) => onChange(e)}
                    />
                    <p>City & state suggested (eg. Pune, Maharashtra)</p>

                    <textarea
                      placeholder='A short bio of yourself'
                      name='bio'
                      value={bio}
                      onChange={(e) => onChange(e)}
                    ></textarea>
                    <p className='form-text'>Tell us a little about yourself</p>
                  </div>

                  <div className='my-2'>
                    <button
                      onClick={() => toggleSocialInputs(!displaySocialInputs)}
                      type='button'
                      style={{ padding: "0.7em 4em" }}
                      className='cbtn'
                    >
                      Add Social media Links
                    </button>
                    <p>Optional</p>
                  </div>

                  {displaySocialInputs && (
                    <Fragment>
                      <div>
                        <i className='fab fa-youtube fa-2x mt-4'></i>
                        <input
                          type='text'
                          placeholder='YouTube URL'
                          name='youtube'
                          value={youtube}
                          onChange={(e) => onChange(e)}
                        />
                      </div>

                      <div>
                        <i className='fab fa-linkedin fa-2x mt-4'></i>
                        <input
                          type='text'
                          placeholder='Linkedin URL'
                          name='linkedin'
                          value={linkedin}
                          onChange={(e) => onChange(e)}
                        />
                      </div>

                      <div>
                        <i className='fab fa-github fa-2x mt-4'></i>
                        <input
                          type='text'
                          placeholder='Github Profile'
                          name='github'
                          value={github}
                          onChange={(e) => onChange(e)}
                        />
                      </div>
                    </Fragment>
                  )}

                  <button className='btn btn-success px-2 my-4'>Create</button>
                  <Link
                    className='btn btn-danger my-4 mx-2 px-2'
                    to='/problems'
                  >
                    Go Back
                  </Link>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

EditProfile.propTypes = {
  createProfile: PropTypes.func.isRequired,
  getCurrentProfile: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  profile: state.profile,
});

export default connect(mapStateToProps, { createProfile, getCurrentProfile })(
  withRouter(EditProfile)
);
